import {trpc} from '@features/utils/trpc';
import {captureException} from '@sentry/react';

export function useCheckoutSession() {
  return trpc.subscription.createCheckoutSession.useMutation({
    onSuccess: (data) => {
      if (!data.url) return;
      window.open(data.url);
    },
    onError: (error) => {
      captureException(error);
    },
  });
}
